import { Link } from "react-router-dom";
import { useApi } from "@/hooks/useApi";
import type { DocItem } from "@/lib/types";
import { Skeleton } from "@/components/base/Skeleton";
import RuleCard from "@/components/feature/rules/RuleCard";

// 메인 홈 «클럽 규정» 섹션 — 조직도 섹션 바로 아래.
// docs 가 비어 있으면 섹션 자체를 렌더링하지 않는다.
export default function RuleSection() {
  const { data, loading } = useApi<DocItem[]>("docs.php");
  const docs = data ?? [];

  if (loading) {
    return (
      <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-16">
        <div className="mx-auto max-w-6xl">
          <div className="mb-6 space-y-2">
            <Skeleton className="h-8 w-40" />
            <Skeleton className="h-4 w-64" />
          </div>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-56 w-full rounded-xl" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  // 규정이 없으면 흔적도 남기지 않는다.
  if (docs.length === 0) return null;

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              클럽 규정
            </h2>
            <p className="mt-2 text-foreground-600">
              정관 · 세칙 · 상조회칙 전문을 확인하세요.
            </p>
          </div>
          <Link
            to="/rules"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
          >
            전체 보기
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {docs.map((doc) => (
            <RuleCard key={doc.code} doc={doc} />
          ))}
        </div>
      </div>
    </section>
  );
}